import {find} from 'lodash'
import UserApi from '@/api/Users/api'

export default {
  computed: {
    usersListProjects: {
      get () {
        return this.$store.getters.usersListProjects
      },
      set (data) {
        this.$store.dispatch('setUsersListProjects', data)
      }
    }
  },
  methods: {
    async getUser (id) {
      if (!id) return ''
      if (typeof id === 'object') return id
      const user = find(this.usersListProjects, {id: id})
      if (user) return user
      try {
        const resp = await UserApi.getUser(id)
        return resp.data
      } catch (e) {
        console.error(e)
        return ''
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixin/getUser.js